import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { Banner } from '../interfaces/banner.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class BannersService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('banner');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  /**
   * Get all banners
   * GET /banner
   */
  getBanners(params?: any): Observable<GenericResponseWithTotal<Banner>> {
    params = params || {};
    return this.http.get<GenericResponseWithTotal<Banner>>(this.apiUrl, { 
      params: this.dataProcess.fitlerParams(params) 
    });
  }

  /**
   * Get a specific banner by ID
   * GET /banner/{id}
   */
  getBannerById(id: number): Observable<Banner> {
    return this.http.get<Banner>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create a new banner
   * POST /banner
   */
  createBanner(bannerData: Partial<Banner>): Observable<Banner> {
    return this.http.post<Banner>(this.apiUrl, bannerData);
  }

  /**
   * Update an existing banner
   * PUT /banner/{banner_id}
   */
  updateBanner(bannerId: number, bannerData: Partial<Banner>): Observable<Banner> {
    return this.http.put<Banner>(`${this.apiUrl}/${bannerId}`, bannerData);
  }

  /**
   * Delete a banner
   * DELETE /banner/{id}
   */
  deleteBanner(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  /**
   * Upload banner image
   * POST /banner/upload-image
   */
  uploadBannerImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/upload-image`, formData);
  }

  /**
   * Toggle banner active status
   */
  toggleBannerStatus(id: number, isActive: number): Observable<Banner> {
    return this.updateBanner(id, { is_active: isActive });
  }

  /**
   * Get only active banners
   */
  getActiveBanners(): Observable<GenericResponseWithTotal<Banner>> {
    return this.getBanners({ is_active: 1 });
  }
}

